import Vue from 'vue';
import VueRouter from 'vue-router';
import { constantRouterMap } from '@/config/router.config';

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap,
  scrollBehavior: () => ({ y: 0 })
});
router.beforeEach((to, from, next) => {
  try{
      if( window.__bl && window.__bl.setPage){
          // from.path === '/' 刷新或其他跳转进页面
          window.__bl.setPage( to.path , from.path !== '/');
      }
  }catch(e){
      console.log(e);
  }
  to.params.roomback = from.params.roomback
  next()
})

export default router;
